/**
 * Mock Backend Helpers
 * Utilities for generating XMPP-compliant stanzas and IDs
 */
import { v4 as uuidv4 } from 'uuid';
// ============================================================================
// JID Utilities
// ============================================================================
export function parseJid(jid) {
    const resourceSplit = jid.split('/');
    const bareJid = resourceSplit[0];
    const resource = resourceSplit[1];
    const domainSplit = bareJid.split('@');
    const local = domainSplit[0];
    const domain = domainSplit[1] || domainSplit[0]; // Handle domain-only JIDs
    const result = { local, domain };
    if (resource !== undefined) {
        result.resource = resource;
    }
    return result;
}
export function getBareJid(jid) {
    return jid.split('/')[0];
}
export function getResource(jid) {
    return jid.split('/')[1];
}
export function buildJid(local, domain, resource) {
    const bareJid = `${local}@${domain}`;
    return resource !== undefined ? `${bareJid}/${resource}` : bareJid;
}
// ============================================================================
// ID Generation
// ============================================================================
export function generateStanzaId() {
    return uuidv4();
}
export function generateMessageId() {
    return `msg_${uuidv4()}`;
}
// ============================================================================
// Timestamp Utilities
// ============================================================================
export function getISOTimestamp() {
    return new Date().toISOString();
}
// ============================================================================
// Stanza Factories
// ============================================================================
export function createPresenceStanza(from, options) {
    const presence = { from };
    if (options?.type !== undefined)
        presence.type = options.type;
    if (options?.show !== undefined)
        presence.show = options.show;
    if (options?.status !== undefined)
        presence.status = options.status;
    if (options?.priority !== undefined)
        presence.priority = options.priority;
    return presence;
}
export function createMessageStanza(options) {
    const message = {
        id: options.id || generateMessageId(),
        from: options.from,
        to: options.to,
    };
    if (options.type !== undefined)
        message.type = options.type;
    if (options.body !== undefined)
        message.body = options.body;
    if (options.subject !== undefined)
        message.subject = options.subject;
    if (options.thread !== undefined)
        message.thread = options.thread;
    return message;
}
export function createRosterItem(jid, options) {
    const bareJid = getBareJid(jid);
    const item = {
        jid,
        bare_jid: bareJid,
        subscription: options?.subscription || 'none',
        groups: options?.groups || [],
    };
    if (options?.name !== undefined)
        item.name = options.name;
    return item;
}
export function createOccupant(nick, options) {
    const occupant = {
        nick,
        affiliation: options?.affiliation || 'none',
        role: options?.role || 'participant',
    };
    if (options?.jid !== undefined)
        occupant.jid = options.jid;
    return occupant;
}
// ============================================================================
// Delay Utility
// ============================================================================
export function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
//# sourceMappingURL=helpers.js.map